<script>
    import {writable} from 'svelte/store';

    import {setContext} from 'svelte';
    import {apiFetch} from '../../../apiFetch';
    import Spinner from "../../../components/spinner/Spinner.svelte";
    import Event from "../../../components/event/Event.svelte";
    import EventFooterNav from "../../../components/event/EventFooterNav.svelte";

    export let eventId;

    let editMode = writable(false);
    setContext('editMode', editMode);
    const toggleEditMode = () => editMode.set(!$editMode);

    const reloadEvent = () => {
      loadEventAgain();
    }
    setContext('reloadEvent', reloadEvent);

    let loadCheck = apiFetch('/organizations/events/' + eventId);

    function loadEventAgain() {
        loadCheck = apiFetch('/organizations/events/' + eventId);
    }
</script>

{#await loadCheck}
    <Spinner/>
{:then data}
    <div class="text-center">
        <small>How your event looks in the I'M IN app:</small>
    </div>

    <div class="wrapper">
        <div class="app-wrapper" id="wrapper">
            <Event event={ data.event }/>
        </div>
    </div>

    <div class="footer-nav-spacer text-center">
        <small>The end</small>
    </div>

    <EventFooterNav event={ data.event } toggleEditMode={toggleEditMode}/>
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}

<style>
    .wrapper {
        position: relative;
    }

    .app-wrapper {
        position: relative;
        border: 2px solid white;
        margin: 20px;
    }

    .footer-nav-spacer {
        margin-bottom: 150px;
    }
</style>